import React from "react";

function AudioImage({ img, isPlaying }) {
  return (
    <>
      <div className=" h-[250px] w-[250px] rounded-full overflow-hidden border-4 border-slate-300/30  z-40">
        <img
          src={img}
          alt=""
          srcSet={img}
          title="Music Picture"
          className={`${isPlaying && "image"} w-full h-full `}
        />
      </div>
      <style jsx="true">{`
        @keyframes spin {
          to {
            transform: rotate(360deg);
          }
        }
        .image {
          animation: spin 10s linear infinite;
        }
      `}</style>
    </>
  );
}

export default AudioImage;
